"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuideType = exports.GroupSessionReaction = exports.InMeetingStatus = void 0;
var InMeetingStatus;
(function (InMeetingStatus) {
    InMeetingStatus["JOINED"] = "joined";
    InMeetingStatus["LEFT"] = "left";
})(InMeetingStatus = exports.InMeetingStatus || (exports.InMeetingStatus = {}));
var GroupSessionReaction;
(function (GroupSessionReaction) {
    GroupSessionReaction["HEART"] = "heart";
})(GroupSessionReaction = exports.GroupSessionReaction || (exports.GroupSessionReaction = {}));
var GuideType;
(function (GuideType) {
    GuideType["GroupFacilitators"] = "GFs";
    GuideType["Gusers"] = "Gusers";
    GuideType["Peers"] = "Peers";
})(GuideType = exports.GuideType || (exports.GuideType = {}));
//# sourceMappingURL=audioRoom.js.map